import HorizontalBarChart from './HorizontalBarChart';

export default HorizontalBarChart;
export { HorizontalBarChart };
